import { BASE_PATH as h, BaseAPI as W, operationServerMap as d } from "../base.js";
import { DUMMY_BASE_URL as S, assertParamExists as C, createRequestFunction as k, serializeDataIfNeeded as v, setSearchParams as g, toPathString as i } from "../common.js";
import p from "axios";
var I = function(t) {
  return {
    merchantWmsSkuCategoryCreateSkuCategory: async (s, a = {}) => {
      C("merchantWmsSkuCategoryCreateSkuCategory", "merchantWmsSkuCategory", s);
      const n = new URL("/merchant/wms/sku/category", S);
      let r;
      t && (r = t.baseOptions);
      const e = {
        method: "POST",
        ...r,
        ...a
      }, o = {}, u = {};
      o["Content-Type"] = "application/json", g(n, u);
      let y = r && r.headers ? r.headers : {};
      return e.headers = {
        ...o,
        ...y,
        ...a.headers
      }, e.data = v(s, e, t), {
        url: i(n),
        options: e
      };
    },
    merchantWmsSkuCategoryDeleteSkuCategory: async (s, a = {}) => {
      C("merchantWmsSkuCategoryDeleteSkuCategory", "skuCategoryId", s);
      const n = "/merchant/wms/sku/category/{skuCategoryId}".replace("{skuCategoryId}", encodeURIComponent(String(s))), r = new URL(n, S);
      let e;
      t && (e = t.baseOptions);
      const o = {
        method: "DELETE",
        ...e,
        ...a
      }, u = {};
      g(r, {});
      let y = e && e.headers ? e.headers : {};
      return o.headers = {
        ...u,
        ...y,
        ...a.headers
      }, {
        url: i(r),
        options: o
      };
    },
    merchantWmsSkuCategoryGetSkuCategory: async (s, a = {}) => {
      C("merchantWmsSkuCategoryGetSkuCategory", "shopId", s);
      const n = "/merchant/wms/sku/category/{shopId}".replace("{shopId}", encodeURIComponent(String(s))), r = new URL(n, S);
      let e;
      t && (e = t.baseOptions);
      const o = {
        method: "GET",
        ...e,
        ...a
      }, u = {};
      g(r, {});
      let y = e && e.headers ? e.headers : {};
      return o.headers = {
        ...u,
        ...y,
        ...a.headers
      }, {
        url: i(r),
        options: o
      };
    },
    merchantWmsSkuCategoryGetSkuListByCategoryId: async (s, a = {}) => {
      C("merchantWmsSkuCategoryGetSkuListByCategoryId", "categoryId", s);
      const n = "/merchant/wms/sku/category/v2/sku/{categoryId}".replace("{categoryId}", encodeURIComponent(String(s))), r = new URL(n, S);
      let e;
      t && (e = t.baseOptions);
      const o = {
        method: "GET",
        ...e,
        ...a
      }, u = {};
      g(r, {});
      let y = e && e.headers ? e.headers : {};
      return o.headers = {
        ...u,
        ...y,
        ...a.headers
      }, {
        url: i(r),
        options: o
      };
    },
    merchantWmsSkuCategoryGetSkusByCategoryId: async (s, a = {}) => {
      C("merchantWmsSkuCategoryGetSkusByCategoryId", "skuCategoryId", s);
      const n = "/merchant/wms/sku/category/skus/{skuCategoryId}".replace("{skuCategoryId}", encodeURIComponent(String(s))), r = new URL(n, S);
      let e;
      t && (e = t.baseOptions);
      const o = {
        method: "GET",
        ...e,
        ...a
      }, u = {};
      g(r, {});
      let y = e && e.headers ? e.headers : {};
      return o.headers = {
        ...u,
        ...y,
        ...a.headers
      }, {
        url: i(r),
        options: o
      };
    },
    merchantWmsSkuCategoryGetSkusByCategoryIdV2: async (s, a = {}) => {
      C("merchantWmsSkuCategoryGetSkusByCategoryIdV2", "skuCategoryId", s);
      const n = "/merchant/wms/sku/category/skus/v2/{skuCategoryId}".replace("{skuCategoryId}", encodeURIComponent(String(s))), r = new URL(n, S);
      let e;
      t && (e = t.baseOptions);
      const o = {
        method: "GET",
        ...e,
        ...a
      }, u = {};
      g(r, {});
      let y = e && e.headers ? e.headers : {};
      return o.headers = {
        ...u,
        ...y,
        ...a.headers
      }, {
        url: i(r),
        options: o
      };
    },
    merchantWmsSkuCategoryGetSkusByCategoryIdV2_1: async (s, a = {}) => {
      C("merchantWmsSkuCategoryGetSkusByCategoryIdV2_1", "skuCategoryId", s);
      const n = "/merchant/wms/sku/category/skus/{skuCategoryId}/v2".replace("{skuCategoryId}", encodeURIComponent(String(s))), r = new URL(n, S);
      let e;
      t && (e = t.baseOptions);
      const o = {
        method: "GET",
        ...e,
        ...a
      }, u = {};
      g(r, {});
      let y = e && e.headers ? e.headers : {};
      return o.headers = {
        ...u,
        ...y,
        ...a.headers
      }, {
        url: i(r),
        options: o
      };
    },
    merchantWmsSkuCategoryUpdateSkuCategory: async (s, a = {}) => {
      C("merchantWmsSkuCategoryUpdateSkuCategory", "merchantWmsSkuCategory", s);
      const n = new URL("/merchant/wms/sku/category", S);
      let r;
      t && (r = t.baseOptions);
      const e = {
        method: "PUT",
        ...r,
        ...a
      }, o = {}, u = {};
      o["Content-Type"] = "application/json", g(n, u);
      let y = r && r.headers ? r.headers : {};
      return e.headers = {
        ...o,
        ...y,
        ...a.headers
      }, e.data = v(s, e, t), {
        url: i(n),
        options: e
      };
    }
  };
}, m = function(t) {
  const s = I(t);
  return {
    async merchantWmsSkuCategoryCreateSkuCategory(a, n) {
      var r, e;
      const o = await s.merchantWmsSkuCategoryCreateSkuCategory(a, n), u = (r = t == null ? void 0 : t.serverIndex) !== null && r !== void 0 ? r : 0, y = (e = d["MerchantWmsSkuCategoryApi.merchantWmsSkuCategoryCreateSkuCategory"]) === null || e === void 0 || (e = e[u]) === null || e === void 0 ? void 0 : e.url;
      return (l, c) => k(o, p, h, t)(l, y || c);
    },
    async merchantWmsSkuCategoryDeleteSkuCategory(a, n) {
      var r, e;
      const o = await s.merchantWmsSkuCategoryDeleteSkuCategory(a, n), u = (r = t == null ? void 0 : t.serverIndex) !== null && r !== void 0 ? r : 0, y = (e = d["MerchantWmsSkuCategoryApi.merchantWmsSkuCategoryDeleteSkuCategory"]) === null || e === void 0 || (e = e[u]) === null || e === void 0 ? void 0 : e.url;
      return (l, c) => k(o, p, h, t)(l, y || c);
    },
    async merchantWmsSkuCategoryGetSkuCategory(a, n) {
      var r, e;
      const o = await s.merchantWmsSkuCategoryGetSkuCategory(a, n), u = (r = t == null ? void 0 : t.serverIndex) !== null && r !== void 0 ? r : 0, y = (e = d["MerchantWmsSkuCategoryApi.merchantWmsSkuCategoryGetSkuCategory"]) === null || e === void 0 || (e = e[u]) === null || e === void 0 ? void 0 : e.url;
      return (l, c) => k(o, p, h, t)(l, y || c);
    },
    async merchantWmsSkuCategoryGetSkuListByCategoryId(a, n) {
      var r, e;
      const o = await s.merchantWmsSkuCategoryGetSkuListByCategoryId(a, n), u = (r = t == null ? void 0 : t.serverIndex) !== null && r !== void 0 ? r : 0, y = (e = d["MerchantWmsSkuCategoryApi.merchantWmsSkuCategoryGetSkuListByCategoryId"]) === null || e === void 0 || (e = e[u]) === null || e === void 0 ? void 0 : e.url;
      return (l, c) => k(o, p, h, t)(l, y || c);
    },
    async merchantWmsSkuCategoryGetSkusByCategoryId(a, n) {
      var r, e;
      const o = await s.merchantWmsSkuCategoryGetSkusByCategoryId(a, n), u = (r = t == null ? void 0 : t.serverIndex) !== null && r !== void 0 ? r : 0, y = (e = d["MerchantWmsSkuCategoryApi.merchantWmsSkuCategoryGetSkusByCategoryId"]) === null || e === void 0 || (e = e[u]) === null || e === void 0 ? void 0 : e.url;
      return (l, c) => k(o, p, h, t)(l, y || c);
    },
    async merchantWmsSkuCategoryGetSkusByCategoryIdV2(a, n) {
      var r, e;
      const o = await s.merchantWmsSkuCategoryGetSkusByCategoryIdV2(a, n), u = (r = t == null ? void 0 : t.serverIndex) !== null && r !== void 0 ? r : 0, y = (e = d["MerchantWmsSkuCategoryApi.merchantWmsSkuCategoryGetSkusByCategoryIdV2"]) === null || e === void 0 || (e = e[u]) === null || e === void 0 ? void 0 : e.url;
      return (l, c) => k(o, p, h, t)(l, y || c);
    },
    async merchantWmsSkuCategoryGetSkusByCategoryIdV2_1(a, n) {
      var r, e;
      const o = await s.merchantWmsSkuCategoryGetSkusByCategoryIdV2_1(a, n), u = (r = t == null ? void 0 : t.serverIndex) !== null && r !== void 0 ? r : 0, y = (e = d["MerchantWmsSkuCategoryApi.merchantWmsSkuCategoryGetSkusByCategoryIdV2_1"]) === null || e === void 0 || (e = e[u]) === null || e === void 0 ? void 0 : e.url;
      return (l, c) => k(o, p, h, t)(l, y || c);
    },
    async merchantWmsSkuCategoryUpdateSkuCategory(a, n) {
      var r, e;
      const o = await s.merchantWmsSkuCategoryUpdateSkuCategory(a, n), u = (r = t == null ? void 0 : t.serverIndex) !== null && r !== void 0 ? r : 0, y = (e = d["MerchantWmsSkuCategoryApi.merchantWmsSkuCategoryUpdateSkuCategory"]) === null || e === void 0 || (e = e[u]) === null || e === void 0 ? void 0 : e.url;
      return (l, c) => k(o, p, h, t)(l, y || c);
    }
  };
}, G = function(t, s, a) {
  const n = m(t);
  return {
    merchantWmsSkuCategoryCreateSkuCategory(r, e) {
      return n.merchantWmsSkuCategoryCreateSkuCategory(r.merchantWmsSkuCategory, e).then((o) => o(a, s));
    },
    merchantWmsSkuCategoryDeleteSkuCategory(r, e) {
      return n.merchantWmsSkuCategoryDeleteSkuCategory(r.skuCategoryId, e).then((o) => o(a, s));
    },
    merchantWmsSkuCategoryGetSkuCategory(r, e) {
      return n.merchantWmsSkuCategoryGetSkuCategory(r.shopId, e).then((o) => o(a, s));
    },
    merchantWmsSkuCategoryGetSkuListByCategoryId(r, e) {
      return n.merchantWmsSkuCategoryGetSkuListByCategoryId(r.categoryId, e).then((o) => o(a, s));
    },
    merchantWmsSkuCategoryGetSkusByCategoryId(r, e) {
      return n.merchantWmsSkuCategoryGetSkusByCategoryId(r.skuCategoryId, e).then((o) => o(a, s));
    },
    merchantWmsSkuCategoryGetSkusByCategoryIdV2(r, e) {
      return n.merchantWmsSkuCategoryGetSkusByCategoryIdV2(r.skuCategoryId, e).then((o) => o(a, s));
    },
    merchantWmsSkuCategoryGetSkusByCategoryIdV2_1(r, e) {
      return n.merchantWmsSkuCategoryGetSkusByCategoryIdV2_1(r.skuCategoryId, e).then((o) => o(a, s));
    },
    merchantWmsSkuCategoryUpdateSkuCategory(r, e) {
      return n.merchantWmsSkuCategoryUpdateSkuCategory(r.merchantWmsSkuCategory, e).then((o) => o(a, s));
    }
  };
}, A = class extends W {
  merchantWmsSkuCategoryCreateSkuCategory(t, s) {
    return m(this.configuration).merchantWmsSkuCategoryCreateSkuCategory(t.merchantWmsSkuCategory, s).then((a) => a(this.axios, this.basePath));
  }
  merchantWmsSkuCategoryDeleteSkuCategory(t, s) {
    return m(this.configuration).merchantWmsSkuCategoryDeleteSkuCategory(t.skuCategoryId, s).then((a) => a(this.axios, this.basePath));
  }
  merchantWmsSkuCategoryGetSkuCategory(t, s) {
    return m(this.configuration).merchantWmsSkuCategoryGetSkuCategory(t.shopId, s).then((a) => a(this.axios, this.basePath));
  }
  merchantWmsSkuCategoryGetSkuListByCategoryId(t, s) {
    return m(this.configuration).merchantWmsSkuCategoryGetSkuListByCategoryId(t.categoryId, s).then((a) => a(this.axios, this.basePath));
  }
  merchantWmsSkuCategoryGetSkusByCategoryId(t, s) {
    return m(this.configuration).merchantWmsSkuCategoryGetSkusByCategoryId(t.skuCategoryId, s).then((a) => a(this.axios, this.basePath));
  }
  merchantWmsSkuCategoryGetSkusByCategoryIdV2(t, s) {
    return m(this.configuration).merchantWmsSkuCategoryGetSkusByCategoryIdV2(t.skuCategoryId, s).then((a) => a(this.axios, this.basePath));
  }
  merchantWmsSkuCategoryGetSkusByCategoryIdV2_1(t, s) {
    return m(this.configuration).merchantWmsSkuCategoryGetSkusByCategoryIdV2_1(t.skuCategoryId, s).then((a) => a(this.axios, this.basePath));
  }
  merchantWmsSkuCategoryUpdateSkuCategory(t, s) {
    return m(this.configuration).merchantWmsSkuCategoryUpdateSkuCategory(t.merchantWmsSkuCategory, s).then((a) => a(this.axios, this.basePath));
  }
};
export {
  A as MerchantWmsSkuCategoryApi,
  I as MerchantWmsSkuCategoryApiAxiosParamCreator,
  G as MerchantWmsSkuCategoryApiFactory,
  m as MerchantWmsSkuCategoryApiFp
};

//# sourceMappingURL=merchant-wms-sku-category-api.js.map